const IMAGE_ELEMENT_SELECTOR =
  'ws-media-container:not([placeholder]) img, ws-block[background-image]:not([background-hidden]):not([background-placeholder]) ws-background-container';

const getUsedImageSources = (element) =>
  [...element.querySelectorAll(IMAGE_ELEMENT_SELECTOR)]
    .map((el) => el.getAttribute('src'))
    .filter((source) => !!source);

export default getUsedImageSources;
